import { render, staticRenderFns } from "./editStorage.vue?vue&type=template&id=0a38c62c&scoped=true&"
import script from "./editStorage.vue?vue&type=script&lang=js&"
export * from "./editStorage.vue?vue&type=script&lang=js&"
import style0 from "./editStorage.vue?vue&type=style&index=0&id=0a38c62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38c62c",
  null
  
)

export default component.exports